module.exports = __webpack_public_path__ + "images/embed/slider-images-track-left.png";